jQuery.noConflict();
jQuery(document).ready(function () {
    if ($('.sliderspecialites').length > 0) {


        $("#1").addClass("sliderspecialites_actif");
        $('#specialites_1').removeClass("hidden");
        
        InitOwlCarousel();

        $(".sliderspecialites_btn").click(function (e) {
            e.preventDefault();
            $('.sliderspecialites_btn').removeClass("sliderspecialites_actif");
            $('.owl-carousel').addClass("hidden");
            $(this).addClass("sliderspecialites_actif");
            var info = $(this).data("caracteristique");
            $('#'+info).removeClass('hidden');
            InitOwlCarousel();
        });

        $("#sliderspecialites_dropdown").on('change', function() {
            $('.owl-carousel').addClass("hidden");
            $('#'+$(this).val()).removeClass('hidden');
            InitOwlCarousel();
        });

        function InitOwlCarousel() {
            //$(".owl-carousel").trigger('refresh.owl.carousel');
            $(".owl-carousel").owlCarousel({
                loop: false,
                nav: true,
                responsive: {
                    // breakpoint from 0 up
                    0: {
                        nav: false,
                        dots: true,
                        items: 1,
                        margin: 30,
                    },
                    // breakpoint from 480 up
                    600: {
                        nav: false,
                        dots: true,
                        items: 2,
                        margin: 30,
                        navText: ["<img src='../wp-content/themes/index/assets/images/icons/Left_Arrow_dark.png'>","<img src='../wp-content/themes/index/assets/images/icons/Right_Arrow_dark.png'>"],
                    },
                    // breakpoint from 425 up
                    1000: {
                        nav: true,
                        dots: false,
                        margin: 30,
                        items: 3,
                        navText: ["<img src='../wp-content/themes/index/assets/images/icons/Left_Arrow_dark.png'>","<img src='../wp-content/themes/index/assets/images/icons/Right_Arrow_dark.png'>"],
                    },
                    1400: {
                        nav: true,
                        dots: false,
                        margin: 30,
                        items: 4,
                        navText: ["<img src='../wp-content/themes/index/assets/images/icons/Left_Arrow_dark.png'>","<img src='../wp-content/themes/index/assets/images/icons/Right_Arrow_dark.png'>"],
                    }
                }
            });
        }
        
    }
});

